/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { useDispatch, useSelector } from "react-redux";
import MSelect from "react-select";
import makeAnimated from "react-select/animated";
import NoticeModal from "views/components/NoticeModal";
import InputLabel from "@material-ui/core/InputLabel";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { textFormat } from "utils/Utils";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../components/UpdateUi/CustomeSelect";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import FindStateData from "helper/FindState";
import { savestateData } from "store/reducers/MasterState/MasterStateSlice";
import FindStructureData from "helper/FindStructureType";

const BranchCreate = ({ classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const animatedComponents = makeAnimated();
  const [codeData, setCode] = useState(params.branchId ? params.branchId : "");
  const [codeState, setCodeState] = useState(false);
  const code = codeData?.replace(/[^a-z0-9_]/gi, "");
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [rawDataDataBranch, setRawDataBranch] = useState({});
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberState, setPhoneNumberState] = useState(false);
  const [alternatePhoneNumber, setAlternatePhoneNumber] = useState("");
  const [alternatePhoneNumberState, setAlternatePhoneNumberState] =  useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [emailAddressState, setEmailAddressState] = useState(false);
  const [plotnumber, setPlotNumber] = useState("");
  const [plotnumberState, setPlotNumberState] = useState(false);
  const [pincode, setPincode] = useState("");
  const [pincodeState, setPincodeState] = useState(false);
  const [state, setState] = useState("");
  const [stateState, setStateState] = useState(false);
  const [city, setCity] = useState("");
  const [cityState, setCityState] = useState(false);
  const [defaultPincodes, setDefaultPincodes] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const [structureTypeId, setStructureTypeId] = useState("");
  const [structureTypeIdState, setStructureTypeIdState] = useState(false);
  const [parentType, setParentType] = useState("");
  const [parentTypeState, setParentTypeState] = useState(false);
  const [parentCode, setParentCode] = useState("");
  const [parentCodeState, setParentCodeState] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [structureTypeList, setstructureTypeList] = useState([]);
  const [parentTypeList, setParentTypeList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [pincodesList, setPincodesList] = useState([]);
  const { stateData }=useSelector((state)=>state.masterstate);
  const viewPage = window.location.href.includes('branch-view');
  const dispatch=useDispatch();
  useEffect(() => {
    getPincodeList();
    (async () => {
      if (params.branchId) {
        setCallInProgress(true);
        // Get Data from API
        const branchDetails = await apiHandler({
          url:
            endpoint.MASTER_PINCODE_FIND_BY_HIERARCHY_CODE +
            params.branchId +
            "?hierarchyCode=" +
            params.branchId,
          authToken: authToken,
        });
        setCallInProgress(false);
        // Set Data to respective fields
        setRawDataBranch(branchDetails.data);
        setCode(textFormat(branchDetails.data.code));
        setName(textFormat(branchDetails.data.name));
        setPhoneNumber(branchDetails.data.phoneNumber);
        setAlternatePhoneNumber(branchDetails.data.alternatePhoneNumber);
        setEmailAddress(textFormat(branchDetails.data.email));
        setPlotNumber(branchDetails.data.address);
        setCity(textFormat(branchDetails.data.city));
        setState(textFormat(branchDetails.data.state));
        setParentType(textFormat(branchDetails.data.parentMasterTypeCode));
        setParentCode(textFormat(branchDetails.data.parentCode));
        getValidParentCode(branchDetails.data.parentMasterTypeCode, false);
        setPincode(branchDetails.data.pincode);
        setPincodes(
          branchDetails.data.pincodes &&
            branchDetails.data.pincodes.map((p) => {
              return { value: p, label: p };
            })
        );
        setDefaultPincodes(
          branchDetails.data.pincodes &&
            branchDetails.data.pincodes.map((p) => {
              return { value: p, label: p };
            })
        );
        if (
          branchDetails.data.parentCode &&
          branchDetails.data.parentCode.indexOf("-") !== -1
        ) {
          let index = branchDetails.data.parentCode.indexOf("-");
          if (index === -1) {
            setParentType(branchDetails.data.parentCode);
          } else {
            setParentType(branchDetails.data.parentCode.substr(0, index));
          }
        }
      }
    })();
  }, []);
  useEffect(()=>{
    if(!stateData.length){
      FindStateData(apiHandler,endpoint,authToken, dispatch, savestateData, setStateList)
    }else{
      setStateList(stateData)
    }
  },[stateData.length])

  useEffect(()=>{
      FindStructureData(apiHandler,endpoint,authToken, setstructureTypeList)
  },[])
  
  useEffect(() => {
    if (rawDataDataBranch.masterTypeCode) {
      const structureType = structureTypeList.filter(
        (z) => z.code === rawDataDataBranch.masterTypeCode
      );
      const parentType = structureTypeList.filter(
        (z) => z.code === rawDataDataBranch.parentCode
      );
      if (structureType.length > 0) {
        setStructureTypeId(textFormat(structureType[0].code));
        setStructureTypeIdState("success");
      }
      if (parentType.length > 0) {
        setParentCode(parentType[0].code);
        setParentCodeState("success");
      }
    }
  }, [structureTypeList]);
  const getPincodeList = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_PINCODE_MAPPED_UNMAPPED,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      setNoticeModalErrMsg(result?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
    } else {
      setPincodesList(
        result?.data?.availablePincodes &&
          result?.data?.availablePincodes.map((p) => {
            return { value: p, label: p };
          })
      );
    }
  };
  // message popup
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (code === "") {
      setCodeState(true);
    } else {
      setCodeState(false);
    }
    if (name === "") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (phoneNumber === "" || phoneNumber.length < 10 || phoneNumber.length > 10) {
      setPhoneNumberState(true);
    } else {
      setPhoneNumberState(false);
    }
    if (alternatePhoneNumber === ""  || alternatePhoneNumber.length < 10 || alternatePhoneNumber.length > 10) {
      setAlternatePhoneNumberState(true);
    } else {
      setAlternatePhoneNumberState(false);
    }
    if (emailAddress === "") {
      setEmailAddressState(true);
    } else {
      setEmailAddressState(false);
    }
    if (plotnumber === "") {
      setPlotNumberState(true);
    } else {
      setPlotNumberState(false);
    }
    if (city === "") {
      setCityState(true);
    } else {
      setCityState(false);
    }
    if (pincode === ""  || pincode.length < 6 || pincode.length > 6) {
      setPincodeState(true);
    } else {
      setPincodeState(false);
    }
    if (state === "") {
      setStateState(true);
    } else {
      setStateState(false);
    }
    if (structureTypeId === "") {
      setStructureTypeIdState(true);
    } else {
      setStructureTypeIdState(false);
    }
    if (parentCode === "") {
      setParentCodeState(true);
    } else {
      setParentCodeState(false);
    }
    if(parentType === ""){
      setParentTypeState(true)
    }else{
      setParentTypeState(false)
    }
    if (
      code &&
      name &&
      phoneNumber &&
      alternatePhoneNumber &&
      emailAddress &&
      plotnumber &&
      city &&
      pincode &&
      state &&
      structureTypeId &&
      parentCode && 
      parentType
    ) {
      return true;
    } else {
      return false;
    }
  };
  const editBranchInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_UPDATE,
      method: "PUT",
      authToken: authToken,
      data: {
        code: code?.toUpperCase(),
        name: name,
        phoneNumber: phoneNumber,
        alternatePhoneNumber: alternatePhoneNumber,
        email: emailAddress,
        address: plotnumber,
        state: state?.toUpperCase(),
        city: city,
        pincode: pincode,
        id: rawDataDataBranch.id,
        masterTypeCode: structureTypeId?.toUpperCase(),
        parentCode: parentCode !== "none" ? parentCode?.toUpperCase() : "",
        parentMasterTypeCode: parentType !== "none" ? parentType?.toUpperCase() : "",
        parentMasterTypeName: parentCode !== "none" ? parentCode?.toUpperCase() : "",
        pincodes: pincodes?.map((p) => p?.value),
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const saveBranchInformation = async () => {
    setCallInProgress(true);
    const bulkData = {
      code: code?.toUpperCase(),
      name: name,
      phoneNumber: phoneNumber,
      alternatePhoneNumber: alternatePhoneNumber,
      email: emailAddress,
      address: plotnumber,
      state: state?.toUpperCase(),
      city: city,
      pincode: pincode,
      masterTypeCode: structureTypeId?.toUpperCase(),
      parentCode: parentCode !== "none" ? parentCode?.toUpperCase() : "",
      parentMasterTypeCode: parentType !== "none" ? parentType?.toUpperCase() : "",
      parentMasterTypeName: parentCode !== "none" ? parentCode?.toUpperCase() : "",
      pincodes: pincodes?.map((p) => p?.value),
    };
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_ADD,
      method: "POST",
      authToken: authToken,
      data: bulkData,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };

  const handlebranchSubmit = async (event) => {
    if (isValidated()) {
      setNoticeModal(false);
      setNoticeModalErrMsg("");
      setNoticeModalHeaderMsg("");

      let status = "";
      if (params.branchId) {
        status = await editBranchInformation();
      } else {
        status = await saveBranchInformation();
      }
      // check for linked and unlinked pincodes
      let linkedPincodes = [],
        unlinkPincodes = [];
      defaultPincodes.forEach((dp) => {
        if (pincodes.find((p) => p.value === dp.value)) {
          // empty
        } else {
          unlinkPincodes.push(dp);
        }
      });
      pincodes.forEach((p) => {
        if (defaultPincodes.find((dp) => p.value === dp.value)) {
          // empty
        } else {
          linkedPincodes.push(p);
        }
      });

      if (status === "SUCCESS" && unlinkPincodes.length > 0) {
        status = await unlinkAllocatedPincodes(
          unlinkPincodes.map((p) => p.value)
        );
      }
      if (status === "SUCCESS") {
        const msg = params.branchId
          ? "Branch updated successfully!"
          : "Branch created successfully!";
        setNoticeModalErrMsg(msg);
        setNoticeModalHeaderMsg("Information");
        setNoticeModal(true);
        setRedirectURL(`/coreservice/branches`);
      }
    }
  };
  const getValidParentCode = async (code, isNew) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_FIND_BY_TYPE_CODE + code.toUpperCase(),
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return;
    } else {
      setParentTypeList(res?.data);
      if (isNew) {
        setParentCode("");
        setParentCodeState("");
      }
    }
  };
  const unlinkAllocatedPincodes = async (unavaliableTemplist) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_PINCODE_DELINK,
      method: "POST",
      authToken: authToken,
      data: {
        pincodes: [...unavaliableTemplist],
        hierarchyCode: code,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const handlecancelbranch = () => {
    navigate("/coreservice/branches");
  };
  const onBlurError = (e, type) => {
    if ((e && e.length < 6 && type === "pincode") || e.length > 6 && type === "pincode") {
      setPincodeState(true)
      }
      if(e && e.length === 6 && type === "pincode") {
        setPincodeState(false)
      }
  
    if ((e && e.length < 10  && type !== "pincode") || e.length > 10 &&  type !== "pincode") {
      if (type === "mobileNumber") {
        setPhoneNumberState(true);
      } else {
        setAlternatePhoneNumberState(true);
      }
    } else{
      if(type === "mobileNumber"){
        setPhoneNumberState(false);
      }else{
      setAlternatePhoneNumberState(false);
      }
    }
  };
  const getSelectedPincodeList = () => [...pincodes];
  const getCompletePincodeList = () => [...defaultPincodes, ...pincodesList];
  const parentTypeChange = (event) => {
    setParentType(event);
    getValidParentCode(event, true);
  };
  const titleName = viewPage ? "View Branch Office" : "Edit Branch Office"; 
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params.branchId ?  titleName : "Create Branch Office" }
          button1={!viewPage && "Save"} 
          button2="Cancel"
          button1click={handlebranchSubmit}
          button2click={handlecancelbranch}
        />
      </Grid>
<Grid  className={classes.inputContainer} style={{width:'100%'}}>
      <Grid item xs={12} sm={12} md={12} >
        <Grid container className={classes.inputFieldContainer}>
          <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Branch Office Code"
              required
              error={!viewPage && codeState}
              id="lp_Branch Code"
              type="code"
              value={code?.toUpperCase() || ""}
              setState={setCode}
              maxLength="3"
              setError={setCodeState}
              disabled={viewPage}
            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Branch Office Name"
              required
              error={!viewPage && nameState}
              id="lp_Branch Name"
              value={name || ""}
              setState={setName}
              setError={setNameState}
              disabled={viewPage}

            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Branch Office Phone Number"
              required
              error={!viewPage && phoneNumberState}
              id="lp_Branch Phone Number"
              value={phoneNumber || ""}
              setState={setPhoneNumber}
              type="number"
              setBlur={onBlurError}
              disabled={viewPage}

              blurLabel="mobileNumber"
              // setError={setPhoneNumberState}
            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Alternate Phone Number"
              required
              disabled={viewPage}

              error={!viewPage && alternatePhoneNumberState}
              id="lp_alternamePhoneNumber"
              value={alternatePhoneNumber || ""}
              setState={setAlternatePhoneNumber}
              type="number"
              setBlur={onBlurError}
              blurLabel="alternateNumber"
              // setError={setAlternatePhoneNumberState}
            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Email Address"
              error={!viewPage && emailAddressState}
              required
              id="lp_emailAddress"
              type="notCapital"
              value={emailAddress || ""}
              setState={setEmailAddress}
              disabled={viewPage}

              setError={setEmailAddressState}
            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Master Type Name *"
              error={!viewPage && structureTypeIdState}
              disabled={viewPage}
              value={structureTypeId}
              setState={setStructureTypeId}
              data={structureTypeList}
              setError={setStructureTypeIdState}
            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Parent Type*"
              error={!viewPage && parentTypeState}
              disabled={viewPage}
              value={parentType}
              setState={parentTypeChange}
              data={structureTypeList}
              setError={setParentTypeState}
            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Parent Type Name*"
              error={!viewPage && parentCodeState}
              value={parentCode}
              
              setState={setParentCode}
              data={parentTypeList}
              setError={setParentCodeState}
              disabled={!parentType || viewPage}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.inputFieldContainer}
      >
        <h2 className={classes.header}>Office Address</h2>
      </Grid>
      <Grid item xs={12} sm={12} md={12} >
        <Grid container className={classes.inputFieldContainer}>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Address"
              required
              error={!viewPage && plotnumberState}
              id="lp_Address"
              value={plotnumber || ""}
              disabled={viewPage}
              setState={setPlotNumber}
              setError={setPlotNumberState}
            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="City"
              required
              error={!viewPage && cityState}
              id="lp_City"
              value={city || ""}
              setState={setCity}
              setError={setCityState}
              disabled={viewPage}
            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Pincode"
              required
              disabled={viewPage}
              error={!viewPage && pincodeState}
              id="lp_Pincode"
              value={pincode || ""}
              setState={setPincode}
              type="number"
              // setError={setPincodeState}
              setBlur={onBlurError}
              blurLabel="pincode"
            />
          </Grid>
            <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="State*"
              value={state}
              error={!viewPage && structureTypeIdState}
              disabled={viewPage}
              setState={setState}
              data={stateList}
              setError={setStateState}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.inputFieldContainer}
      >
        <h2 className={classes.header}>Linked Pincodes</h2>
      </Grid>
      <Grid item xs={12} sm={12} md={12} >
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <InputLabel>Pincodes*</InputLabel>
            <MSelect
              closeMenuOnSelect={false}
              components={animatedComponents}
              value={getSelectedPincodeList()}
              isMulti
              isDisabled={viewPage}
              onChange={(e) => {
                !viewPage && setPincodes(e);
              }}
              options={getCompletePincodeList()}
            />
          </Grid>{" "}
        </Grid>{" "}
      </Grid>
      </Grid>
      <NoticeModal
        noticeModal={noticeModal}
        noticeModalHeader={noticeModalHeaderMsg}
        noticeModalErrMsg={noticeModalErrMsg}
        closeModal={closeNoticeModal}
      />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default BranchCreate;
